<template>
  <svg
    width="457"
    height="463"
    viewBox="0 0 457 463"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <mask :id="`artefactMask-${template}`">
        <path
          d="M459 204L328.426 374L282.223 352L124.53 293L70.2912 288L4 238L32.1235 125L45.1808 127L72.3001 149H276.196L389.696 125L459 204Z"
          fill="white"
          v-if="template === 0"
        />
        <path
          d="M336.596 58L456 227.843L411.606 416.048L403.952 439L387.113 422.169L255.463 227.843L68.7024 370.145L35.0241 390.036L24.3082 348.723L9 247.735L126.873 79.4217L336.596 58Z"
          fill="white"
          v-if="template === 1"
        />
        <path
          d="M399 246.093L285.318 449L265.256 437.261L73 44.8619L76.3436 13L375.595 105.231L399 246.093Z"
          fill="white"
          v-if="template === 2"
        />
      </mask>
    </defs>

    <image
      :mask="`url(#artefactMask-${template})`"
      width="100%"
      height="100%"
      y="0"
      x="0"
      :xlink:href="url"
    />
  </svg>
</template>
<script>
export default {
  props: {
    url: { type: String, required: true },
    template: { type: Number, default: 0 },
  },
};
</script>
<style lang="scss" scoped>
svg {
  width: 100%;
}
</style>
